<template>
  <div>
    <v-card class="mb-3">
      <v-card-title>
        <span class="title font-weight-bold blue--text text--darken-3">Datos del Centro</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs9 lg9>
            <v-text-field
              type="text"
              label="Nombre del CCTP"
              v-model="centro.institucioneducativa"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs3 lg3>
            <v-text-field
              type="text"
              label="Sigla"
              v-model="centro.sigla"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs6 md6 lg3>
            <v-text-field
              type="text"
              label="Departamento"
              v-model="centro.departamento"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md6 lg3>
            <v-text-field
              type="text"
              label="Provincia"
              v-model="centro.provincia"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 lg3>
            <v-text-field
              type="text"
              label="Municipio"
              v-model="centro.municipio"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 lg3>
            <v-text-field
              type="text"
              label="Comunidad"
              v-model="centro.comunidad"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: "datos-centro",
  data: () => ({
    centro: {
      institucioneducativa: '',
      sigla: '',
      departamento: '',
      provincia: '',
      municipio: '',
      comunidad: ''
    },
    params: {}
  }),
  mounted() {
    this.params = Service.getParams();
    this.getDatosCentro();
    
  },
  methods: {
    getDatosCentro() {
      axios
        .get(Service.getBase() + "centro/" + this.params.ie_id, Service.getHeader())
        .then(response => {
          this.centro = response.data;
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
  }
};
</script>

<style lang="stylus">
#drawer
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto

.v-list__tile__action
  min-width: 40px;

.v-list__group__header .v-list__tile
  padding-left: 0

.v-list__group__items .v-list__tile
  padding-left: 57px

</style>
